<template>
  <div>
    <div>
      <div
        v-for="(link, linkIndex) in form.links"
        :key="linkIndex"
        class="localLink"
      >
        <BaseInput
          label="URL"
          v-model="link.url"
          placeholder="https://example.com"
        />
        <BaseInput
          label="Tekst"
          v-model="link.text"
        />

        <p
          class="removeLocalNote"
          @click="onRemoveLink(linkIndex)"
        >
          Fjern link
        </p>
      </div>
    </div>

    <a
      href="#"
      class="addLocalLink highlight"
      @click.prevent="onAddLink"
    >
      <font-awesome-icon icon="plus-circle" /> Tilføj link
    </a>
  </div>
</template>

<script>
import BaseInput from './BaseInput.vue';

export default {
    name: 'LocalLinks',
    components: { BaseInput },
    props: {
        form: { type: Object, required: true },
    },
    methods: {
        onAddLink() {
            if (Array.isArray(this.form.links)) {
                this.form.links.push({ url: '', text: '' });
            } else {
                this.form.links = [];
                this.form.links.push({ url: '', text: '' });
            }
        },
        onRemoveLink(localIndex) {
            this.form.links = this.form.links.filter((a, index) => index !== localIndex);
        },
    },
};
</script>

<style lang="scss" scoped>
.addLocalLink {
    margin-bottom: 20px;
    margin-top: 10px;
    display: block;
    padding-top: 10px;
    text-align: center;
    font-weight: bold;
}

.removeLocalNote {
    text-align: right;
    font-size: 12px;
    font-weight: 300;
    font-style: italic;
    margin-top: -5px;
    cursor: pointer;
}

.localLink {
    padding: 20px;

    &:nth-child(odd) {
        background: #f6f6f6;
    }
}
</style>
